module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kg-Ld.c29f0e83.png";